import type { ShapeData } from '@/lib/shapes/types/shape-data'
import { resolveKindId } from '@/lib/elements/stowed-element-builder'

const GROUP_KIND_ID = 7
const PAGE_NUMBER_KIND_ID = 5
const POLYLINE_KIND_ID = 9

/**
 * Returns true when a shape can receive a fill color — via drag-drop or the fill picker.
 * Excludes groups, page numbers, polylines (kind 9), and photo-filled shapes.
 * Polylines have no fill_style in the proto so a fill is lost after reload.
 * Photo-filled shapes persist fill through photoFill, not fill_style, so a color
 * drop would show on canvas but disappear on reload.
 * useFillColorApply.fillTargets delegates to this function as the single source of truth.
 */
export function isColorDropTarget(shape: ShapeData): boolean {
  if (shape.photoFill) return false

  const k = resolveKindId(shape)

  return k !== GROUP_KIND_ID && k !== PAGE_NUMBER_KIND_ID && k !== POLYLINE_KIND_ID
}
